import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Layout from "./layout/Layout";
import Dashboard from "./pages/Dashboard";
import RdpList from "./pages/RdpList";
import UserManagement from "./pages/UserManagement";
import AdminGuard from "./hoc/adminGaurd";
import NotFound from "./pages/notFound";
import UserActivity from "./pages/UserActivity";
import Setting1 from "./pages/settings/DataCenterLocation";
import Setting2 from "./pages/settings/RemoteControl";
import UserManagementAdd from "./pages/UserManagementAdd";
import ServerListAdd from "./pages/ServerListAdd";
import DataCenterLocation from "./pages/settings/DataCenterLocation";
import RemoteControl from "./pages/settings/RemoteControl";
import ServerType from "./pages/settings/ServerType";
import Server from "./pages/settings/Server";
import RemotePanel from "./pages/settings/RemotePanel";

const App = () => {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route  path="/admin"element={<AdminGuard><Layout /></AdminGuard>}>
            <Route index element={<Dashboard />} />
            <Route path="user-management" element={<UserManagement />} />
            <Route path="rdpList" element={<RdpList />} />
            <Route path="activity" element={<UserActivity />} />
            <Route
              path="user-management/userAdd"
              element={<UserManagementAdd />}
            />
            <Route path="rdpList/serviceAdd" element={<ServerListAdd />} />
            <Route path="dataCenter" element={<DataCenterLocation />} />
            <Route path="remoteControl" element={<RemoteControl />} />
            <Route path="serverType" element={<ServerType />} />
            <Route path="server" element={<Server />} />
            <Route path="remotePanel" element={<RemotePanel />} />
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </>
  );
};

export default App;
